module.exports = __webpack_public_path__ + "static/media/AttentionIcon.8c0fb18b.svg";